import { useTheme } from "../context/ThemeContext";
import { RadiusBorder } from "./RadiusBorder";

const OverViewItemCard: React.FC<{ cardView: React.ReactNode, value: React.ReactNode, title: string, textColor?: string, iconColor?: string, extClsName?: string }> = ({ cardView, value, title, textColor = 'text-cyan-400', iconColor = 'bg-cyan-400', extClsName = "" }) => {
  const { theme } = useTheme();
  return (
    <div className={`flex items-center gap-[24px] relative p-[24px] ${extClsName}`}>
      <div className={`${iconColor} min-w-8 min-h-8 sm:min-w-[40px] sm:min-h-10 flex items-center justify-center rounded-full absolute top-0 right-0`}>
        {cardView}
      </div>
      <div className="flex flex-col gap-[16px]">
        <p className={`text-[14px] sm:text-[14px] ${theme === 'dark' ? 'text-white/70' : 'text-black/70'}`}>{title}</p>
        <div className={`text-[32px] sm:text-[16px] lg:text-[32px] leading-none font-medium ${textColor}`}>{value}</div>
      </div>
      <RadiusBorder />
    </div>
  )
}

export default OverViewItemCard;